<template>
    <v-snackbar width="380" multi-line v-model="snackBarPayload.show" :color="color" :timeout="timeout" top right>
        <template v-slot:action="{ attrs }">
            <v-btn v-bind="attrs" icon @click="snackBarPayload.show = false" small>
                <v-icon :class="[textColor]" small>close</v-icon>
            </v-btn>
        </template>
        <div class="d-flex">
            <v-icon :class="[textColor]" class="align-self-start mr-7">{{ icon }}</v-icon>
            <div style="max-width: 237px" class="text-caption" v-html="this.snackBarPayload.message" :class="[textColor]" @click="isWrapped = !isWrapped"></div>
        </div>
    </v-snackbar>
</template>

<script>
import { mapState } from 'vuex';
import translate from '@/utils/translate.util';

export default {
    data: () => ({
        text: "I'm a multi-line snackbar.",
        color: '#156d91',
        textColor: 'white--text',
        timeout: undefined,
        icon: null,
        isWrapped: true
    }),
    watch: {
        snackBarPayload(val) {
            this.changeState(val);
        }
    },
    computed: {
        ...mapState('base', ['snackBarPayload']),
        wrappedText() {
            const MAX_WORDS = 100;
            let text = '';
            if (this.snackBarPayload.isApi) text = translate(this.snackBarPayload.message, 'full', this.$i18n.locale).name;
            else text = this.$t(this.snackBarPayload.message, this.snackBarPayload.messagePayload);

            const words = (text || '').split(' ');
            if (words.length > MAX_WORDS && this.isWrapped) {
                return words.slice(0, MAX_WORDS).join(' ') + '...';
            }
            return text;
        }
    },
    methods: {
        changeState(obj) {
            switch (obj.color) {
                case 'info':
                case 'success':
                    this.color = '#25934E';
                    this.icon = 'mdi-information-variant';
                    this.timeout = 20000;
                    this.textColor = 'white--text';
                    break;
                case 'warning':
                    this.color = '#FFB600';
                    this.icon = 'priority_high';
                    this.timeout = -1;
                    this.textColor = 'black--text';
                    break;
                case 'error':
                    this.color = '#FF6140';
                    this.icon = 'mdi-close-thick';
                    this.timeout = -1;
                    this.textColor = 'error-text--text';
                    break;
                default:
                    this.color = '#156d91';
                    this.icon = 'priority_high';
                    this.timeout = 20000;
                    this.textColor = 'white--text';
                    break;
            }
        }
    }
};
</script>

<style lang="scss">
.v-snack {
    transform: translate(-9%, 150px);
}
.v-snack__action {
    align-self: baseline;
}
</style>
